<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" class="title">
          <app-editor :value="JSON.parse(data.description)" :editable="false" />
        </v-col>
        <v-col cols="12" sm="6" v-for="(answer, index) in answers" :key="'Question' + index">
          <app-pronunciation-card
            :content="data.question_group.questions[index].content"
            :src="data.question_group.questions[index].question_file"
            :value="audios[index].audioBlob ? audios[index].audioBlob : answer.audio_file"
            @input="onInput($event, index)"
          >
            <template #title>
              <span></span>
            </template>
          </app-pronunciation-card>
        </v-col>
        <v-col cols="12" class="text-center mt-8">
          <v-btn
            v-if="!answered"
            class="white--text text-capitalize"
            color="#29284c"
            :loading="loading"
            :disabled="answered"
            @click="save"
          >
            Save
          </v-btn>
          <ProgressResetButton
            v-else
            :small="false"
            :depressed="false"
            :stepType="stepType"
            :stepUuid="data.uuid"
            @reset="onReset"
          />
          <v-btn
            v-if="isTeacher"
            class="white--text ml-2 text-capitalize"
            color="#29284c"
            :loading="loadingAssign"
            :disabled="finished || disabled"
            @click="assign(data.uuid)"
          >
            {{
              finished || disabled
                ? "Already assigned"
                : `Assign to ${student.first_name} ${student.last_name}`
            }}
          </v-btn>
        </v-col>
        <v-col cols="12">
          <app-comment-group ref="commentGroup" divider :uuid="data.comment_group" />
        </v-col>
      </v-row>
    </v-container>
    <app-student-note v-if="!isTeacher && qualification.note" :note="qualification.note" absolute />
    <app-qualification
      v-if="isTeacher && !qualification.note && qualification.uuid"
      :qualification="qualification"
      absolute
      @new-qual="qualification = $event"
    />
  </div>
</template>
<script>
import PronunciationCard from "../PronunciationCard.vue";
import homeworkLessonMixin from "@/mixins/homeworkLessonMixin";
import ProgressResetButton from "@/components/Utils/ProgressResetButton.vue";

export default {
  components: {
    appPronunciationCard: PronunciationCard,
    ProgressResetButton,
  },
  mixins: [homeworkLessonMixin],
  methods: {
    onInput($event, index) {
      this.audios.splice(index, 1, {
        audioBlob: $event,
      });
    },
  },
};
</script>
